import { Injectable } from '@angular/core';
import {BausteinHeaderConfig} from '../model/baustein-header-config';
import {StructuredContent, Baustein, TariffOption} from '../model/structured-content-models';

@Injectable({
  providedIn: 'root'
})
export class StructuredContentService {

  private structuredContent: StructuredContent;

  constructor() {}

  setConfig(config: StructuredContent) {
    this.structuredContent = config;
  }

  getConfig() {
    return this.structuredContent;
  }

  getBausteinRowList() {
    return this.structuredContent.bausteinRowList;
  }

  getBausteinHeadlineConfig(baustein: Baustein): BausteinHeaderConfig {
    const headlineConfig = new BausteinHeaderConfig();
    headlineConfig.headlineWithInfo = baustein.headlineWithInfo;
    headlineConfig.tariffOption = baustein.tariffOption;
    return headlineConfig;
  }

  getTariffOptionByCalculationId(calculationId: string): TariffOption {
    for (const rowListItem of this.structuredContent.bausteinRowList) {
      for (const bli of rowListItem.bausteinList) {
        if (bli.tariffOption && bli.tariffOption.calculationId === calculationId) {
          return bli.tariffOption;
        }
      }
    }
    return null;
  }
}
